import { render, staticRenderFns } from "./manualDetail.vue?vue&type=template&id=d50c455e"
import script from "./manualDetail.vue?vue&type=script&lang=js"
export * from "./manualDetail.vue?vue&type=script&lang=js"
import style0 from "./manualDetail.vue?vue&type=style&index=0&id=d50c455e&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d50c455e')) {
      api.createRecord('d50c455e', component.options)
    } else {
      api.reload('d50c455e', component.options)
    }
    module.hot.accept("./manualDetail.vue?vue&type=template&id=d50c455e", function () {
      api.rerender('d50c455e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sys/menu/manualDetail.vue"
export default component.exports